module.exports = __webpack_public_path__ + "static/img/ent-detail-52.d6d4e79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-52.jpg
// module id = oucY
// module chunks = 52